export default __webpack_public_path__ + "static/media/Icon_Community_B.cd4283b8.svg";